/*global translate*/
import React from 'react'
import RxShareScreen from './../sharescreen'

const { rxgetLocal } = global.rootRequire('classes/request')
const { rxaget ,changeColorSVG} = global.rootRequire('classes/ulti')
const { checkNameUser } = global.rootRequire('classes/chat')
global.isclient && require('./rxCallScreen.css')

export const renderComponent = (vm) => {
  return (<div>
    {!vm.state.flagCalling && <div className='zchat_callscreen_center'>
      <div className='call-loader'></div>
      <div className='call-loader-text'>{translate('Connecting')} ...</div>
    </div>}
  	{ vm.state.flagCalling && vm.renderZCall() }
  </div>)
}

export const renderZCall = (vm) => {
  let typeCall = rxaget(vm.callObj, 'media_type', 1)
  let remote_uin = rxaget(global.rxu.array(rxaget(vm.callObj, 'callee_uins', [])).filter(ele => (ele !== vm.userid.toString())), '0', '')
  let objUsers = vm.users

  let uname = rxaget(vm.remoteUser, 'full_name', '') || rxaget(vm.remoteUser, 'phone', '')

  return <div className='zchat_callscreen' onClick={e => vm.handleClickOutside(e)}>
	  
  	<div className='zchat_callscreen_bg'></div>

    {vm.state.ringtone && <audio controls autoPlay hidden loop>
      <source src='./sounds/soundcallmess.mp3' type='audio/mpeg' />
    </audio>}

  	<div className='zchat_callscreen_main'>
  		<div className='zchat_callcenter_new'>
      {vm.state.flagStartCall && <div className='device-trouble-icon' onClick={(e) => vm.showCallTrouble()}><span className='icon-info'></span></div>}

  			<div className='zchat_callbox'>
	        <div className='zchat_callInfo'>

		        <div className='zcall_container'>
		        	<div className='zcall_info'>{uname}</div>
              {(vm.remoteUser && vm.remoteUser.phone && (vm.remoteUser.phone !== uname)) && <div className='zcall_content_desc'>
                {vm.remoteUser.phone}
              </div>}
              {(!vm.state.flagStartCall && !vm.state.flagError) && <div className='zcall_content'>
                {(vm.state.descAlertCall === 0) ? translate('Contacting...') : (vm.state.descAlertCall === 1) ? translate('Ringing') :  (vm.state.descAlertCall === 2) ? translate('Is Calling') : translate('Connecting') }
              </div>}
              {vm.state.flagStartCall && <div className='zcall_content'>
                {!vm.state.flagEnding && <div>{rxaget(vm.state.time, 'm', '00')}:{rxaget(vm.state.time, 's', '00')}</div>}
                {vm.state.flagEnding && translate('Call Ended')}
              </div>}

	            <div className='zcall_avatar'>
                <img className='zcall_avatarimg' src={`${global.rxu.config.cdn_endpoint}` + rxaget(vm.remoteUser, 'profile_url', '')} alt='profile_url' onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }}/> 
              </div>

              {vm.state.flagError && <div className='zcall_desc_err'>
                {translate('Check input/output device sound please')}
              </div>}
              
	            <div className='zcall_buttons' id='zcall_buttons'>
	            	<div className='zcall_group_button'>
                  {vm.state.flagStartCall && <div className='zcall_button' onClick={e => vm.changeFlagMic()}>
                    <img className='zcall_btn zcall_btn_bg' alt='' src={changeColorSVG('./images/default/icons/mic_enable.svg')} style={(vm.state.flagMic) ? {display: 'block'} : {display: 'none'}} />
                    <img className='zcall_btn zcall_btn_border' alt='' src={changeColorSVG('./images/default/icons/mic_disable.svg')} style={(vm.state.flagMic) ? {display: 'none'} : {display: 'block'}}/>
                  </div>}

                  {/*(vm.state.flagStartCall && typeCall === 1) && <div className='zcall_button' onClick={e => vm.changeFlagCamera()}>
                    <img className='zcall_btn zcall_btn_border' alt='' src={changeColorSVG('./images/default/icons/call_video_enable.svg')} style={(!vm.state.flagCamera) ? {display: 'block'} : {display: 'none'}}/>
                    <img className='zcall_btn zcall_btn_bg' alt='' src={changeColorSVG('./images/default/icons/call_video_disable.svg')} style={(vm.state.flagCamera) ? {display: 'block'} : {display: 'none'}} />
                  </div>*/}
	                <div className='zcall_button' >
	                  <img className='zcall_cancel' alt='' src={changeColorSVG('./images/default/icons/cancelcall.png')} onClick={e => vm.onClickStopCall()} />
	                </div>
                  {(!vm.state.flagStartCall && !vm.isRoomCreator && !vm.state.flagError) && <div className='zcall_button' >
	                  <img className='zcall_answer' alt='' src={changeColorSVG('./images/default/icons/acceptcall.png')} onClick={e => vm.acceptCall()} />
	                </div>}

	              </div>
	            </div>

	          </div>
	        </div>
	      </div>

        <div className='device-setting-icon icon-settings' onClick={(e) => vm.showDeviceSetting()}></div>
        {vm.state.flagShowSetting && <div className='device-setting'>
          <img className='device-setting-close' alt='' src={changeColorSVG('./images/default/icons/icon-close.png')} onClick={e => vm.onClickCloseSetting()}/>
          <div className='device-setting-row'>
            <div className='device-setting-label'>Audio Input</div>
            <label className="device-select-box" >
              <select className='device-setting-select' value={vm.state.audioinputDefault} onChange={vm.changeDeviceAudioInput}>
                {vm.state.audioinput.map(deviceInfo => <option key={deviceInfo.value} value={deviceInfo.value}>{deviceInfo.text}</option>)}
              </select>
            </label>
          </div>
          <div className='device-setting-row'>
            <div className='device-setting-label'>Audio Output</div>
            
            <label className="device-select-box" >
              <select value={vm.state?.audiooutputDefault || ''} onChange={vm.changeDeviceAudioOutput}>
                {vm.state.audiooutput.map(deviceInfo => <option key={deviceInfo.value} value={deviceInfo.value}>{deviceInfo.text}</option>)}
              </select>
            </label>
          </div>
        </div>}

	    </div>

	    <div className='zchat_videocallcenter_new' style={((typeCall === 2 || vm.state.flagCamera) && vm.state.flagStartCall) ? {display: 'block'} : {display: 'none'}}>
        {vm.state.flagStartCall && <div className='device-trouble-icon' onClick={(e) => vm.showCallTrouble()}><span className='icon-info'></span></div>}

        <div className='zchat_videocallinfo'>
          <div className='zcall_info'>{uname}</div>
          <div className='zcall_content'>
            {rxaget(vm.state.time, 'm', '00')}:{rxaget(vm.state.time, 's', '00')}
          </div>
        </div>  

        <div className='zchat_videocallmain'>
          <div className='zchat_videocall_remote'>
            <video id="remote-video-screen" autoPlay="autoplay"></video>
            <audio id="remote-audio-screen" autoPlay></audio>
          </div>

          <div className='zchat_videocall_local'>
            <video id="local-video-screen" autoPlay="autoplay" muted="muted"></video>
            <audio id="local-audio-screen" autoPlay muted="muted"></audio>
          </div>
        </div>

        <div className='zcall_buttons' id='zcall_buttons'>
          <div className='zcall_group_button'>
            {vm.state.flagStartCall && <div className='zcall_button' onClick={e => vm.changeFlagMic()}>
              <img className='zcall_btn zcall_btn_bg' alt='' src={changeColorSVG('./images/default/icons/mic_enable.svg')} style={(vm.state.flagMic) ? {display: 'block'} : {display: 'none'}} />
              <img className='zcall_btn zcall_btn_border' alt='' src={changeColorSVG('./images/default/icons/mic_disable.svg')} style={(vm.state.flagMic) ? {display: 'none'} : {display: 'block'}}/>
            </div>}

            {/*(vm.state.flagStartCall && typeCall === 1) && <div className='zcall_button' onClick={e => vm.changeFlagCamera()}>
              <img className='zcall_btn zcall_btn_border' alt='' src={changeColorSVG('./images/default/icons/call_video_enable.svg')} style={(!vm.state.flagCamera) ? {display: 'block'} : {display: 'none'}}/>
              <img className='zcall_btn zcall_btn_bg' alt='' src={changeColorSVG('./images/default/icons/call_video_disable.svg')} style={(vm.state.flagCamera) ? {display: 'block'} : {display: 'none'}} />
            </div>*/}
            {vm.state.flagStartCall && <div className='zcall_button' onClick={e => vm.onClickShareScreen()}>
              {(vm.state.flagShareScreen === true) && <img className='zcall_btn zcall_btn_sharescreen zcall_btn_active' alt='' src={changeColorSVG('./images/default/icons/icon-sharescreen-white.svg')}/>}
              {(vm.state.flagShareScreen === false) && <img className='zcall_btn zcall_btn_sharescreen' alt='' src={changeColorSVG('./images/default/icons/icon-sharescreen.svg')}/>}
            </div>}

            <div className='zcall_button' >
              <img className='zcall_cancel' alt='' src={changeColorSVG('./images/default/icons/cancelcall.png')} onClick={e => vm.onClickStopCall()}  />
            </div>

          </div>
        </div>

        <div className='device-setting-icon icon-settings' onClick={(e) => vm.showDeviceSetting()}></div>

        {vm.state.flagShowSetting && <div className='device-setting'>
          <img className='device-setting-close' alt='' src={changeColorSVG('./images/default/icons/icon-close.png')} onClick={e => vm.onClickCloseSetting()}/>
          <div className='device-setting-row'>
            <div className='device-setting-label'>Audio Input</div>
            <label className="device-select-box" >
              <select value={vm.state.audioinputDefault} onChange={vm.changeDeviceAudioInput}>
                {vm.state.audioinput.map(deviceInfo => <option key={deviceInfo.value} value={deviceInfo.value}>{deviceInfo.text}</option>)}
              </select>
            </label>
          </div>
          <div className='device-setting-row'>
            <div className='device-setting-label'>Audio Output</div>
            <label className="device-select-box" >
              <select className='device-setting-select' value={vm.state.audiooutputDefault} onChange={vm.changeDeviceAudioOutput}>
                {vm.state.audiooutput.map(deviceInfo => <option key={deviceInfo.value} value={deviceInfo.value}>{deviceInfo.text}</option>)}
              </select>
            </label>
          </div>
        </div>}
        
      </div>

      {(vm.state.flagSourceScreen === true) && <RxShareScreen 
          closePopupShareScreen={() => vm.closePopupShareScreen()}
          confirmSourceShareScreen={(screenActiveId) => vm.confirmSourceShareScreen(screenActiveId)}
        />
      }

      {vm.state.showCallTrouble &&
        <div className='call-showdebug'>
          <div className='item-left'>
            <div className='item-title'>Stream Info</div>
            <div className='item-title'>Local Stream</div>
            <div className='item-title'>Remote Stream</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>Bandwidth Speed</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'bandwidthSpeed', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'bandwidthSpeed', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>STUN/TURN?</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'localIceType', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'remoteIceType', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>Codecs</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'codecsSend', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'codecsRecv', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>Encryption</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'encryptedAs', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'encryptedAs', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>IP Address</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'externalIPAddressLocal', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'externalIPAddressRemote', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>Resolutions</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'videoResolutionsForSenders', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'videoResolutionsForReceivers', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>Data</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'totalDataForSenders', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'totalDataForReceivers', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>Latency</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'audiolatency', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'audiolatency', '')}</div>
          </div>
          <div className='item-left'>
            <div className='item-title'>PacketsLost</div>
            <div className='item-content'>{rxaget(vm.state.localStream, 'audiopacketsLost', '')}</div>
            <div className='item-content'>{rxaget(vm.state.remoteStream, 'audiopacketsLost', '')}</div>
          </div>

        </div>
      }

  	</div>
    
  </div>
}